import React from 'react';
import dayjs from 'dayjs';
import { DEFAULT_TIMEZONE, getEpochTime } from 'utils/date';
import CountdownClockBanner from './countdown-clock-banner';
import PromoBanner from './promo-banner';

const DynamicBanner = ({
  promoColorScheme,
  rotationSpeed,
  promoMessage1,
  promoMessage2,
  promoMessage3,
  promoMessage4,
  saleColorScheme,
  discountMessage,
  saleEndDate,
  saleEndTime,
  ctaText,
  ctaLink,
  finalSaleColorScheme,
  finalDiscountMessage,
  finalSaleEndDate,
  finalSaleEndTime,
  isSaleActive,
  hasFinalSale,
}) => {
  const promoMessages = [promoMessage1, promoMessage2, promoMessage3, promoMessage4].filter(Boolean);

  if (!isSaleActive && promoMessages.length === 0) return null;

  const firstEndTimestamp = `${saleEndDate}T${saleEndTime}`;
  const finalEndTimestamp = hasFinalSale && `${finalSaleEndDate}T${finalSaleEndTime}`;
  const currentEST = dayjs().tz(DEFAULT_TIMEZONE);
  const firstEndDate = isSaleActive && getEpochTime(firstEndTimestamp);
  const finalEndDate = hasFinalSale && getEpochTime(finalEndTimestamp);
  const isAfterFirstEndDate = currentEST.isAfter(firstEndDate);
  const isAfterFinalEndDate = currentEST.isAfter(finalEndDate);
  const firstSaleConfig = {
    colorScheme: saleColorScheme,
    message: discountMessage,
    ends: firstEndDate,
    cta: { text: ctaText, href: ctaLink },
  };
  const finalSaleConfig = {
    colorScheme: finalSaleColorScheme,
    message: finalDiscountMessage,
    ends: finalEndDate,
    cta: { text: ctaText, href: ctaLink },
  };
  const shouldShowFinalSale = hasFinalSale && isAfterFirstEndDate && !isAfterFinalEndDate;
  return !isAfterFirstEndDate || shouldShowFinalSale ? (
    <>
      {shouldShowFinalSale && <CountdownClockBanner {...finalSaleConfig} />}
      {!isAfterFirstEndDate && <CountdownClockBanner {...firstSaleConfig} />}
    </>
  ) : (
    <PromoBanner
      messages={promoMessages}
      autoplayDelay={Number(rotationSpeed)}
      colorScheme={promoColorScheme}
    />
  );
};

export default DynamicBanner;
